<template>
<div class="Fdns-audit-fluid">
	<div class="fdnsaudit-data">
		<label>{{cqa.Order}}. {{cqa.Question}}</label>
		<ob-input class="answer-txt" type="text" :disabled="!isEdit" v-model="cqa.Answer" :class="{'ob-vuelidate_input-error':$v.cqa.Answer.$error}"></ob-input>
		<span class="ob-vuelidate_error-msg" v-if="$v.cqa.Answer.$dirty && !$v.cqa.Answer.requiredIf">Please enter answer</span>
		<div class="edit-row">
			<div class="update-date">
				<img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/FDNS/question-mode-icon.svg` " width="15" height="15" slot="reference" style="margin-right:5px;" />
				<p v-if="cqa.IsManual" class="manual-txt">Manual</p>
				<p v-else class="manual-txt">Automatic</p>
			</div>
			<div class="edit-hide-data">
				<div class="hide-data" v-if="isHRManager">
					<div class="hide-answer" v-if="cqa.IsHide == false">
						<img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/FDNS/hide-icon.svg`" width="15" height="15" slot="reference" style="margin-right:5px;" />
						<a class="hide-ans">Hide Question</a>
					</div>
					<div class="hide-answer" v-if="cqa.isHide == true">
						<img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/FDNS/unhide-icon.svg`" width="15" height="15" slot="reference" style="margin-right:5px;" />
						<a class="edit-ans">Unhide Question</a>
					</div>
					<div class="edit-answer" v-if="isEdit == false">
						<img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/FDNS/pencil-icon.svg`" width="15" height="15" slot="reference" style="margin-right:5px;" />
						<a @click="isEdit = true" class="edit-ans">Edit Answer</a>
					</div>
					<div class="edit-answer" v-else>
						<img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/FDNS/pencil-icon.svg`" width="15" height="15" slot="reference" style="margin-right:5px;" />
						<a @click="saveAnswer" class="edit-ans">Save Answer</a>
					</div>
				</div>
				
			</div>
		</div>
	</div>
</div>
</template>
<script>
import { requiredIf } from "vuelidate/lib/validators";
export default {
  props: ["qa"],
  data() {
    return {
      cqa: null,
      isEdit: false
    };
  },
  validations() {
    return {
      cqa: {
        Answer: {
          requiredIf: requiredIf(() => {
            return this.isEdit == true;
          })
        }
      }
    };
  },
  created() {
    this.cqa = __.cloneDeep(this.qa);
  },
  methods: {
    saveAnswer() {
      this.$v.cqa.$touch();
      if (this.$v.cqa.$invalid != true) {
        this.isEdit = false;
      }
    }
  }
};
</script>
<style scoped lang="scss">
.fdnsaudit-data {
  margin: 20px 30px 20px 0;
  label {
    color: #666;
    font-size: 14px;
    font-weight: 600;
  }
  .ob-vuelidate_error-msg {
    color: #d60000;
    margin-left: 15px;
    margin-top: -8px;
    display: block;
  }
}
.edit-ans {
  text-decoration: underline;
  color: #4a90e2;
  font-size: 13px;
  font-style: italic;
  font-weight: 600;
}
.hide-ans {
  text-decoration: underline;
  color: #d60000;
  font-size: 13px;
  font-style: italic;
  font-weight: 600;
}

.edit-row {
  margin-left: 15px;
  .update-date {
    display: inline;
  }
  .edit-hide-data {
    float: right;
    .hide-answer {
      float: left;
      margin-right: 15px;
    }
    .edit-answer {
      float: right;
    }
  }
} //Main Section ENDS

//Main Section start
.answer-txt {
  display: block;
  margin: 10px 0;
  width: 100%;
  margin-left: 15px;
}

.manual-txt {
  display: inline;
  color: #b3b2bb;
  font-size: 13px;
  font-weight: 600;
}
/* Change color of dropdown links on hover */

.Fdns-audit-fluid {
  padding: 0px 20px 0 20px;
}
.fdnsaudit-container {
  background: #fff;
}
.fdns-footer {
  padding: 0 0 20px 0;
  text-align: center;
}
// TABS STARTS
.fdns-header_tabs {
  margin: 20px 0 0 0;
  ul {
    padding: 0;
    width: 60%;
    display: inline-block;
    li {
      list-style: none;
      display: inline;
      padding: 7px 0px 7px 20px;
      a {
        font-size: 16px;
        font-weight: 600;
        color: #b0b2b5;
      }
    }
    li.active {
      border-bottom: 3px solid #2d4972;
      a {
        color: #143361;
      }
    }
  }
}
// TABS ENDS
.MT-Content {
  margin-top: 8%;
  text-align: center;
  width: 100%;
  height: 100%;
  vertical-align: middle;
  display: block;
  font-weight: 600;
}
.heading-txt {
  padding: 15px 15px 15px 22px;
  border-bottom: 1px solid #4a90e3;
  position: -webkit-sticky;
  position: sticky;
  top: -15px;
  background: #fff;
  z-index: 1;
  p {
    color: #4a90e3;
    font-size: 16px;
    font-weight: 600;
  }
}

.fixed-dropdown {
  position: fixed;
  right: 15px;
  top: 191px;
  z-index: 2;
}
</style>


// WEBPACK FOOTER //
// src/components/ESSProfile/FDNS/FDNSQuestionAndAnswer.vue